import { Component } from '@poa/core';
import React from 'react';
import { observable } from '@poa/state';
import { getProfileIcon } from '../../icons/profile';
import { AccountModalSocials } from './social-list';
import Select from 'react-select';

const placeholederImage = require('../../../img/placeholder_man.jpg');


export class PrefetchSelect extends React.Component {
  static defaultProps = { clearable: true, isSearchable: true };
  state = { data: [], current: this.props.current || null, loading: true };

  componentDidMount() {
    this.env.http.get(this.props.type, { params: { AccountId: this.props.accountId } }).then(response => {
      this.mapResponseToState(response.data);
    });
  }

  refreshData() {
    this.env.http.get(this.props.type, { params: { AccountId: this.props.accountId } }).then(response => {
      this.mapResponseToState(response.data);
    });
  }

  updateLeadOptions = (inputValue) => {
    if (this.props.types) {
      Promise.all(
        this.props.types.map(type => this.env.http.get(
          type, { params: { Name: inputValue, AccountId: this.props.accountId } }
        ).then(response => response.data))
      ).then(data => {
        const items = new Map();
        [].concat(...data).forEach(item => {
          if (!items.has(item.id)) {
            items.set(item.id, item);
          }
        });
        this.mapResponseToState([...items.values()]);
      });
    } else if (this.props.type) {
      this.env.http.get(
        this.props.type, { params: { Name: inputValue, AccountId: this.props.accountId } }
      ).then(response => {
        this.mapResponseToState(response.data);
      });
    }
  };

  mapResponseToState(response) {

    let current = response.find(item => item.id === this.props.current);

    let loadedData = response.map(item => ({
      label: `${item.first_name} ${item.last_name}`,
      value: item.id
    }));

    let selectedOption = current ? { label: `${current.first_name} ${current.last_name}`, value: current.id } : null;
    let foundElement = this.state.data.find(element => element.value === this.props.current);


    if (foundElement) {
      selectedOption = foundElement;
      let foundElementIsPresent = loadedData.find(element => element.value === this.props.current);

      if (!foundElementIsPresent) {
        loadedData.push({
          label: foundElement.label,
          value: foundElement.id
        })
      }
    }

    this.setState({
      data: loadedData,
      selectedOption: selectedOption,
      loading: false
    });
  }

  handleChange = selectedOption => {
    this.setState({ selectedOption });
    this.props.onChange(selectedOption ? selectedOption.value : null);
    this.props.handleChangeExtended && this.props.handleChangeExtended(selectedOption);
  };

  handleInputChange = (inputValue) => {
    if (!inputValue) {
      return;
    }
    if ((this.props.types && (
      this.props.types.includes('scouts') ||
      this.props.types.includes('account-managers') ||
      this.props.types.includes('teamleads') ||
      this.props.types.includes('operators') ||
      this.props.types.includes('operators_shifts') ||
      this.props.types.includes('managers')
    )) || (['teamleads', 'operators', 'operators_shifts', 'managers', 'scouts', 'account-managers'].includes(this.props.type))) {

      if (inputValue.length >= 2) {
        this.updateLeadOptions(inputValue);
      } else {
        if (typeof this.props.accountId === 'undefined') {
          this.setState({ data: [] });
        } else {
          this.refreshData();
        }
      }
    }
  };

  render() {
    return (
      <Select
        style={this.props.optionalStyle}
        searchable={this.props.isSearchable}
        name='form-field-name'
        disabled={!this.props.editMode}
        value={this.state.selectedOption || ''}
        isLoading={this.state.loading}
        onChange={this.handleChange}
        options={this.state.data}
        clearable={this.props.clearable}
        placeholder={this.props.placeholder || 'Выберите...'}
        noResultsText={this.t('noResults')}
        onInputChange={this.handleInputChange}
      />
    );
  }
}

PrefetchSelect = Component({ namespaces: ['account-lead-popup'] })(PrefetchSelect);


class AccountGeneralInfo extends React.Component {
  store; // injected by Poa
  actions; // injected by Poa

  localState = observable({
    isPasswordVisible: false, passwordMessage: 'Показать пароль',
    getProps: () => this.props,

  });


  handlePasswordVisibility = async (id) => {
    try {
      await this.env.api.users.fetchAccountPassword(id);
      this.localState.isPasswordVisible = !this.localState.isPasswordVisible;
    } catch (error) {
      console.error(error);
      this.localState.passwordMessage = 'Доступ запрещен';
    }
  };

  getUserName = (model, originalModel, isEdit) => {
    if (isEdit) {
      return (
        <div className='account-general-info__edit'>
          <input
            type='text'
            className='account-general-info__item__edit'
            value={model.firstName}
            onChange={e => (model.firstName = e.target.value)} />
          <input
            type='text'
            className='account-general-info__item__edit'
            value={model.lastName}
            onChange={e => (model.lastName = e.target.value)} />
          <div className='account-general-info__item'>
            <Select
              searchable={false}
              name='status'
              value={model.status}
              onChange={target => { model.status = target.value; }}
              clearable={false}
              options={[
                { value: 'active', label: 'active' },
                { value: 'inactive', label: 'inactive' },
                { value: 'rejected', label: 'rejected' },
                { value: 'suspended', label: 'suspended' },
                { value: 'blocked', label: 'blocked' },
                { value: 'deleted', label: 'deleted' },
                { value: 'transferred', label: 'transferred' },
                { value: 'transfered', label: 'transfered' },
                { value: 'on verification', label: 'on verification' }
              ]}
            />
          </div>
          <div className='account-general-info__item' style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            gap: "5px",
          }}>
            <span>Контроль :</span>
            <input
              type="checkbox"
              name="is_agency"
              checked={model.isInternal === true}
              onChange={e => { model.isInternal = e.target.checked ? true : false }}
            />
          </div>
        </div>
      )
    } else {
      return (
        <div className='main-title-name'>
          {originalModel.firstName} {originalModel.lastName}
          <p style={{ color: (originalModel.status === 'active') ? "green" : "red", marginLeft: "20px" }}>
            ({originalModel.status})
          </p>
        </div>
      )
    }
  }

  getEditableField(object, path) {
    const pathArray = path.split('.');

    if (pathArray.length === 1) {
      return (
        <input
          type='text'
          className='edit'
          value={object.accountNumber}
          onChange={(newValue) => {
            object.accountNumber = newValue.target.value;
          }}
        />
      );
    }

    let value = object;
    for (let i = 0; i < pathArray.length; i++) {
      value = value[pathArray[i]];
    }

    return (
      <input
        type='text'
        className='edit'
        value={value}
        onChange={(newValue) => {
          let newObject = { ...object };
          let temp = newObject;
          for (let i = 0; i < pathArray.length - 1; i++) {
            temp = temp[pathArray[i]];
          }
          temp[pathArray[pathArray.length - 1]] = newValue.target.value;
        }}
      />
    );
  }

  getShowEditField = (modelValue, originalValue, isEdit, fieldStyle) => {
    if (isEdit) {
      return this.getEditableField(this.store.accounts.model, modelValue)
    }

    return <div className={fieldStyle || "info-operator-name"}>{originalValue}</div>
  }

  render() {
    const { model, originalModel, isEdit } = this.store.accounts;

    return (
      <div className='general_info__content'>
        {
          originalModel !== null ?
            <>
              <div className='main-row'>
                <div style={{ width: "100%" }}>
                  <div className='title-name-row'>
                    {this.getUserName(model, originalModel, isEdit)}
                    <AccountModalSocials socials={originalModel.socials} isEdit={isEdit} />
                  </div>
                  <div className='row-info'>
                    <div className='img-div'>
                      <img className='row-img'
                        src={originalModel.account.dreammarriage.profilePhoto}
                        onError={(e) => { e.target.src = placeholederImage; }}
                        alt='client-profile' />
                    </div>
                    <div className="info-column">
                      <div className='info-row'>
                        {getProfileIcon('idCard')}
                        <div className='info-title'>ID :</div>
                        <div className='info-operator-name'>{originalModel.id}</div>
                      </div>
                      <div className='info-row'>
                        {getProfileIcon('idCard')}
                        <div className='info-title'>№ :</div>
                        {this.getShowEditField(
                          "accountNumber",
                          originalModel.accountNumber,
                          isEdit,
                          "info-operator-name")}

                      </div>
                      <div className='info-row'>
                        {getProfileIcon('birthday')}
                        <div className='info-title'>регистрация :</div>
                        {this.getShowEditField(
                          "account.dreammarriage.registrationDate",
                          originalModel.account.dreammarriage.registrationDate,
                          isEdit,
                          'info-text')}
                      </div>
                      <div className='info-row'>
                        {getProfileIcon('birthday')}
                        <div className='info-title'>перевод :</div>
                        {this.getShowEditField(
                          "account.dreammarriage.transferDate",
                          originalModel.account.dreammarriage.transferDate,
                          isEdit,
                          'info-text')}
                      </div>
                      <div className='info-row'>
                        {getProfileIcon('password2')}
                        <div className='info-title'>пароль :</div>


                        {this.localState.isPasswordVisible && (
                          this.getShowEditField(
                            "account.dreammarriage.password",
                            originalModel.account.dreammarriage.password,
                            isEdit,
                            'info-operator-name'))
                        }
                        {!this.localState.isPasswordVisible && (
                          <button className='account-info__val' style={{ color: this.localState.passwordMessage === 'Доступ запрещен' ? 'red' : 'black' }}
                            onClick={() => this.handlePasswordVisibility(model.id)}
                          >
                            {this.localState.passwordMessage}
                          </button>
                        )}

                      </div>
                    </div>
                    <div className="info-column">
                      <div className='info-row'>
                        {getProfileIcon('suitcase')}
                        <div className='info-title'>телефон :</div>
                        {this.getShowEditField(
                          "account.dreammarriage.telephone",
                          originalModel.account.dreammarriage.telephone,
                          isEdit,
                          'info-text')}
                      </div>
                      <div className='info-row'>
                        {getProfileIcon('email')}
                        <div className='info-title'>email :</div>
                        {this.getShowEditField(
                          "account.dreammarriage.email",
                          originalModel.account.dreammarriage.email,
                          isEdit,
                          'info-text')}
                      </div>
                      <div className='info-row'>
                        {getProfileIcon('password')}
                        <div className='info-title'>emailPass :</div>
                        {this.getShowEditField(
                          "account.dreammarriage.emailPass",
                          originalModel.account.dreammarriage.emailPass,
                          isEdit,
                          'info-text')}
                      </div>
                      <div className='info-row'>
                        {getProfileIcon('group')}
                        <div className='info-title'>панель :</div>
                        <div className='info-text'>
                          {originalModel.account.dreammarriage.panel}
                        </div>
                      </div>
                      <div className='info-row'>
                        {getProfileIcon('suitcase')}
                        <div className='info-title'>ник :</div>
                        {this.getShowEditField(
                          "account.dreammarriage.nickname",
                          originalModel.account.dreammarriage.nickname,
                          isEdit,
                          'info-operator-name')}
                      </div>
                    </div>
                    <div className="info-column">
                      <div className='info-row'>
                        {getProfileIcon('location')}
                        <div className='info-title'>регистратор :</div>
                        {this.getShowEditField(
                          "account.dreammarriage.registrator",
                          originalModel.account.dreammarriage.registrator,
                          isEdit,
                          'info-text')}
                      </div>
                      <div className='info-row'>
                        {getProfileIcon('email')}
                        <div className='info-title'>уровень анкеты :</div>
                        {this.getShowEditField(
                          "salary.accountLevel",
                          originalModel.salary.accountLevel,
                          isEdit,
                          'info-text')}
                      </div>
                      <div className='info-row'>
                        {getProfileIcon('group')}
                        <div className='info-title'>доверие :</div>
                        <div className='info-text'>
                          {originalModel.account.dreammarriage.trust}
                        </div>
                      </div>
                      <div className='info-row'>
                        {getProfileIcon('dollar')}
                        <div className='info-title'>гарантированная выплата :</div>
                        {this.getShowEditField(
                          "account.dreammarriage.salary",
                          originalModel.account.dreammarriage.salary,
                          isEdit,
                          'info-text')}
                      </div>
                      <div className='info-row'>
                        {getProfileIcon('dollar')}
                        <div className='info-title'>план :</div>
                        {this.getShowEditField(
                          "account.dreammarriage.plan",
                          originalModel.account.dreammarriage.plan,
                          isEdit,
                          'info-donate')}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='report-row'>
                <div style={{ width: '100%' }}>
                  <div className='row-title'>Персонал</div>
                  <ul className='account-general-info__list'>
                    <li className='account-general-info__item'>
                      <div className='account-info__name'>менеджер</div>
                      <PrefetchSelect
                        editMode={isEdit}
                        type='managers'
                        current={model.account.dreammarriage.manager_id}
                        clearable={true}
                        accountId={originalModel.id}
                        handleChangeExtended={val => {
                          if (val === null) {
                            return (model.account.dreammarriage.manager_id = null);
                          }
                        }}
                        onChange={value => {
                          return (model.account.dreammarriage.manager_id = value);
                        }}
                      />
                    </li>
                    <li className='account-general-info__item'>
                      <div className='account-info__name'>тимлид</div>
                      <PrefetchSelect
                        editMode={isEdit}
                        type='teamleads'
                        current={model.account.dreammarriage.teamlead_id}
                        accountId={originalModel.id}
                        onChange={value => (model.account.dreammarriage.teamlead_id = value)}
                        handleChangeExtended={val => {
                          if (val === null) {
                            return (model.account.dreammarriage.teamlead_id = null);
                          }
                        }}
                      />
                    </li>
                    <li className='account-general-info__item'>
                      <div className='account-info__name'>оператор</div>
                      <PrefetchSelect
                        editMode={isEdit}
                        type='operators'
                        current={model.account.dreammarriage.operator_id}
                        accountId={originalModel.id}
                        onChange={value => (model.account.dreammarriage.operator_id = value)}
                        handleChangeExtended={val => {
                          if (val === null) {
                            return (model.account.dreammarriage.operator_id = null);
                          }
                        }}
                      />
                    </li>
                    <li className='account-general-info__item'>
                      <div className='account-info__name'>скаут</div>
                      <PrefetchSelect
                        editMode={isEdit}
                        type='scouts'
                        current={model.account.dreammarriage.scout_id}
                        accountId={originalModel.id}
                        onChange={value => (model.account.dreammarriage.scout_id = value)}
                      />
                    </li>
                    <li className='account-general-info__item'>
                      <div className='account-info__name'>аккаунт менеджер</div>
                      <PrefetchSelect
                        editMode={isEdit}
                        type='account-managers'
                        accountId={originalModel.id}
                        current={model.account.dreammarriage.account_manager_id}
                        onChange={value => (model.account.dreammarriage.account_manager_id = value)}
                      />
                    </li>
                  </ul>
                </div>
              </div>

              

            </>
            :
            <div className='main-row'>
              <div className='no-profile-found-text'>
                {getProfileIcon('noUser')}
                Профиль не найден
              </div>
            </div>
        }
      </div>
    );
  }
}

export default Component({ namespaces: ['account-general-info'] })(AccountGeneralInfo);